import {AdvancedTable, useAdvancedTable} from '@eitje/web_components'
import {TABLE_INFO} from './constants'
import {columns} from './columns'

export const UsersAdvancedTable = ({searchResults}) => {
	'use no memo' // @tanstack/react-table is not compatible with the react compiler
	const tableData = useAdvancedTable({data: searchResults, columns, TABLE_INFO})
	const rowTo = row => `/users/${row.original.id}`

	return <AdvancedTable data={tableData} rowTo={rowTo} />
}
